// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XJvq","col":"styles_col__11mOB"};